export default abstract class BaseSystemLocalizationDictionary {
    InternalError: string = '';
    AccessDenied: string = '';
}